query findEventMarkets(
  $id: UUID!
) {
  event: eventByEventId(eventId: $id) {
    eventId
    matchState
    markets: marketsByEventId(
      filter: {
        source: {
          in: ["INTERNAL_AGGREGATION"],
        },
      }
      condition: {
        displayStatus: "ON"
      }
    ) {
      nodes {
        displayStatus
        offeringStatus
        resultingStatus
        marketCode
        marketId
        marketType
        selections
        source
        inPlay
        marketSummary
      }
    }
  }
}
